import { styleConstants } from '@paywithextend/components'
import React from 'react'
import Tooltip from 'src/components/Tooltip/Tooltip'
import Trns from 'src/localization/Trns'
import { css } from 'styled-components'

interface ExpiresTooltipProps {
  openLeft: boolean
  className?: string
}

const ExpiresTooltip: React.FC<ExpiresTooltipProps> = (
  props,
): React.ReactElement => {
  return (
    <Tooltip openLeft={props.openLeft} className={props.className}>
      <p>
        <Trns
          source={
            '${expirationDate} is used when entering payment information. It is automatically set on card creation, and is unchangeable. ${itIsNot}'
          }
          expressions={{
            expirationDate: (
              <span
                css={css`
                  font-family: ${styleConstants.fontFamilies.medium};
                `}
              >
                <Trns source={'Expiration Date'} />
              </span>
            ),
            itIsNot: (
              <span
                css={css`
                  font-family: ${styleConstants.fontFamilies.italic};
                `}
              >
                <Trns
                  source={
                    "It is not the same as your card's Active Until Date, which determines how long your card is usable."
                  }
                />
              </span>
            ),
          }}
        />
      </p>
      <p
        css={css`
          margin-top: 12px;
        `}
      >
        <Trns
          source={
            'In the rare scenario where your card hits this expiration date, your card will be deactivated. You will need to request or create a new Virtual Card.'
          }
        />
      </p>
    </Tooltip>
  )
}

export default ExpiresTooltip
